<template>
  <div class="crypto_items_list_wrapper">
    <div class="crypto_item_payment_method"
         v-for="method in cryptoItemList"
         :key="method.code"
    >
      <v-tooltip
        top
        :disabled="!(method.code === 'ETH' && isNotValidPriceForEthereum)"
        max-width="388px"
      >
        <template #activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            text
            :ripple="!(method.code === 'ETH' && isNotValidPriceForEthereum)"
            color="primary"
            class="crypto_item"
            :class="{
              selected: method.selected,
              inactiveButton: method.code === 'ETH' && isNotValidPriceForEthereum
            }"
            :loading="loadingBalance"
            @click="handleMethodClick(method)"
          >
          <span class="crypto_item_main">
            <img
              :class="{
                inactiveImg: method.code === 'ETH' && isNotValidPriceForEthereum
            }"
              :src="require('@/assets/crypto/' + method.icon)"
              alt="Crypto icons"
            />
          </span>
          </v-btn>
        </template>
        <span
          class="payment-checkout-tooltip-text white--text"
        >
          {{ $t('plans.paymentIsNotAvailable') }}
        </span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
  import { mapFields } from "vuex-map-fields";
  import { mapGetters } from "vuex";
  import {
    BTC_CODE,
    DOGE_CODE,
    ETH_CODE,
    LTC_CODE,
    PAYMENT_METHOD_CRYPTOMUS_OR_INXY,
  } from '@/constants/plans'

  export default {
    name: 'CryptoPaymentMethodsList',

    data () {
      return {
        cryptoItemList: [
          { protocol: "BTC", code: BTC_CODE, name: "Bitcoin", icon: "BTC.svg", provider: PAYMENT_METHOD_CRYPTOMUS_OR_INXY, selected: true },
          { protocol: "LTC", code: LTC_CODE, name: "Litecoin", icon: "LTC.svg", provider: PAYMENT_METHOD_CRYPTOMUS_OR_INXY, selected: false },
          { protocol: "ETH", code: ETH_CODE, name: "Ethterium", icon: "ETH.svg", provider: PAYMENT_METHOD_CRYPTOMUS_OR_INXY, selected: false },
          { protocol: "DOGE", code: DOGE_CODE, name: "Dogecoin", icon: "DOGE.svg", provider: PAYMENT_METHOD_CRYPTOMUS_OR_INXY, selected: false },
        ],
        selectedMethodIndex: 0
      }
    },

    computed: {
      ...mapGetters({
        loadingBalance: 'plans/loadingBalance',
        paymentSummary: 'plans/paymentSummary',
        currentCase: 'plans/currentCase'
      }),
      ...mapFields('plans', ['invoice']),

      isNotValidPriceForEthereum () {
        return this.paymentSummary.total < 23
      }
    },

    created () {
      this.handleMethodClick(this.cryptoItemList[0])
    },

    methods: {
      handleMethodClick (method) {
        if (method.code === 'ETH' && this.isNotValidPriceForEthereum) return

        if (!method.selected) {
          this.cryptoItemList[this.selectedMethodIndex].selected = false

          const selectedMethodIndex = this.cryptoItemList.indexOf(method)

          this.cryptoItemList[selectedMethodIndex].selected = true
          this.selectedMethodIndex = selectedMethodIndex
        }

        this.invoice.currency = "USD"
        this.invoice.coin = method.code

        this.$store.dispatch('plans/updatePaymentInfo', {
          coin: method.code,
          provider: method.provider ? method.provider : 'upgrading',
          paymentMethod: method.paymentMethod ? method.paymentMethod : 'crypto'
        })

        this.$store.dispatch('plans/setCoin', method.code)
      }
    }
  }
</script>

<style scoped lang="scss">
  .crypto_items_list_wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin-top: 24px;
    width: max-content;
  }

  * {
    font-family: PT Root UI,sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
  }

  .crypto {
    &__item {
      background: white !important;
      margin: 0 auto;
      width: 286px;
      height: 40px;
      border: 1px solid #DEDFE2;
      box-sizing: border-box;
      border-radius: 20px;
      padding: 7.5px 25px 7.5px 10px;

      &_main {
        display: flex;
        align-items: center;

        img {
          margin-right: 9px;
        }

        span {
          font-size: 1em;
          line-height: 19px;
          color: #000000;
          text-transform: none;
        }
      }
    }
  }

  .crypto_item {
    background: white !important;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 1 20%;
    height: 46px!important;
    border: 0.941637px solid #E1E1E4;
    border-radius: 5.64982px;
    margin: 0!important;
  }

  .crypto_item_main {
    display: flex;
    align-items: center;
    text-align: left;
  }

  span {
    font-size: 1em;
    line-height: 19px;
    color: #000000;
    text-transform: none;
  }

  .protocol {
    font-size: 1em;
    line-height: 19px;
    color: #757575;
    margin-left: 2px;
    margin-top: 5px;
  }

  .selected {
    background: rgba(181, 71, 233, 0.1)!important;
    border: 1px solid #B547E9!important;
  }

  .inactiveButton:hover,
  .inactiveButton:before,
  .inactiveButton:focus {
    background: var(--v-background-secondary-default-base,#f4f4f7);
  }

  .inactiveButton {
    border: 1px solid #DDDDE0;
    background: var(--v-background-secondary-default-base, #F4F4F7);
  }

  .inactiveImg {
    opacity: 0.3;
  }

  .crypto_item_payment_method {
    display: inline-block;
  }

  .payment-checkout-tooltip-text {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
</style>